import { render, staticRenderFns } from "./xuInner.vue?vue&type=template&id=af5e8f68&scoped=true&"
import script from "./xuInner.vue?vue&type=script&lang=js&"
export * from "./xuInner.vue?vue&type=script&lang=js&"
import style0 from "./xuInner.vue?vue&type=style&index=0&id=af5e8f68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5e8f68",
  null
  
)

export default component.exports